@import "../../../../styles/_media.css";

.searchInner {
  &.isMobile {
    background-color: #e1e1e1;

    &.forModal {
      background-color: var(--color-white);

      .searchInput {
        background-image: url("../../../../web2-assets/search-expanded.svg");
        background-repeat: no-repeat;
        background-position: right;
      }
    }

    .searchInput {
      height: 30px;
    }
  }
}

.searchButton {
  &.isMobile {
    position: unset;
    background: none;
    height: auto;
  }
}

.searchCloseButton {
  &.isMobile {
    height: 40px;
  }
}

.searchButton,
.searchCloseButton {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.searchExpanded {
  height: 35px;
  transition: all 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.searchInput {
  width: 100%;
  font-size: var(--font-xs);
  font-family: var(--font-family-lato);
  padding: 2px;
  height: 28px;
}

.searchCloseButton {
  background-color: #e1e1e1;
}
